/* Retouren: runtime (2026-NL, F0008 fase 1, één pagina sinds F0024).
 *
 * Eén wizard, vier stappen, plus de status- en track & trace-modus. Alle paneeltjes
 * staan al in de HTML (zie sections/main-retouren-2026nl.liquid); dit script wisselt
 * ze om, vult ze en praat met de app proxy. Het keuzeblok bovenaan (data-modus)
 * schakelt tussen de twee modi en houdt ?stap=track in de URL bij.
 *
 * Endpoints (relatief, via de app proxy, Shopify hangt zelf signature en
 * logged_in_customer_id aan het verzoek, wij sturen dus nooit een klant-id mee):
 *   POST {basis}/order-opzoeken   { ordernummer, postcodeOfEmail? }
 *   GET  {basis}/redenen          -> [{ code, label }]
 *   POST {basis}/aanmelden        { ordernummer, postcodeOfEmail?, regels, redenCode, opmerking? }
 *   POST {basis}/track-en-trace   { retournummer, postcodeOfEmail?, trackAndTrace?, vervoerder? }
 *
 * Het antwoordcontract ligt vast in docs/tasks/…/F0008, maar de exacte veldnamen van de
 * backend staan nog niet in beton. Daarom leest dit script elk veld via `pak()` met een
 * lijstje aliassen: wijkt de backend af in casing of taal, dan blijft de pagina werken
 * in plaats van leeg te blijven. Wat er echt niet is, wordt netjes weggelaten.
 *
 * Alle tekst van de bezoeker en van de server gaat via textContent de DOM in, nooit via
 * innerHTML. Een producttitel of foutmelding uit een API is geen vertrouwde HTML.
 */
(function () {
  'use strict';

  var TIJDSLIMIET = 12000;

  /* ─── Teksten ────────────────────────────────────────────────────────── *
   * Sleutel -> [Nederlands, Vlaams]. Eén element betekent: in beide markten
   * dezelfde tekst. De markt komt uit de sectie-config ("regio": "nl" | "be",
   * gevuld door region-2026nl). Ophalen doe je met t('sleutel').
   *
   * De Nederlandse strings staan hier letterlijk zoals ze altijd waren, pas ze
   * niet "even mee" aan bij een Vlaamse wijziging.
   *
   * De statuslabels (In behandeling, Goedgekeurd, …) staan bewust NIET in deze
   * tabel: die zijn in beide markten gelijk en horen bij statusInfo().
   */
  var TEKSTEN = {
    /* Knoppen in de wachtstand */
    bezig:              ['Bezig…'],
    bezigZoeken:        ['Bezig met zoeken…'],
    bezigAanmelden:     ['Bezig met aanmelden…'],
    bezigOpslaan:       ['Bezig met opslaan…'],

    /* Algemene foutmeldingen */
    netwerkTitel:       ['We konden ons systeem even niet bereiken'],
    netwerkTekst:       ['Controleer je internetverbinding en probeer het nog eens. Lukt het daarna nog niet, mail ons dan via ',
                         'Kijk je internetverbinding na en probeer het nog eens. Lukt het daarna nog niet, mail ons dan via '],
    rustigTitel:        ['Even rustig aan'],
    rustigTekst:        ['Je hebt net al een paar pogingen gedaan. Wacht een minuutje en probeer het dan opnieuw.'],
    serverTitel:        ['Er ging iets mis aan onze kant', 'Er liep iets mis aan onze kant'],
    serverTekst:        ['Probeer het zo nog eens. Blijft het misgaan, mail ons dan via ',
                         'Probeer het zo nog eens. Blijft het mislopen, mail ons dan via '],

    /* Stap 1: bestelling opzoeken */
    ordernummerLeegTitel: ['Vul je ordernummer in'],
    ordernummerLeegTekst: ['Je vindt het in je bestelbevestiging en op de pakbon.'],
    identLeegTitel:     ['Vul je postcode of e-mailadres in'],
    identLeegTekst:     ['Daarmee controleren we of de bestelling van jou is.',
                         'Zo zijn we zeker dat de bestelling van jou is.'],
    orderWegTitel:      ['We konden deze bestelling niet vinden'],
    orderWegTekst:      ['Controleer je ordernummer en je postcode of e-mailadres.',
                         'Kijk je ordernummer en je postcode of e-mailadres even na.'],
    orderWegExtra:      [' Vul hieronder je postcode of e-mailadres in en probeer het opnieuw.'],
    opzoekenMisluktTitel: ['Opzoeken is niet gelukt'],
    opzoekenMisluktTekst: ['Controleer je gegevens en probeer het nog eens.',
                         'Kijk je gegevens na en probeer het nog eens.'],

    /* Orderkop en regels */
    bestellingVoor:     ['Bestelling '],
    besteldOp:          ['Besteld op '],
    termijnVoor:        ['Je kunt tot ', 'Je kan tot '],
    termijnNa:          [' dagen na ontvangst retourneren.'],
    stukBesteld:        [' stuk besteld'],
    stuksBesteld:       [' stuks besteld'],
    regelGeblokkeerd:   ['Voor dit artikel loopt al een retour, dus je kunt het niet nog een keer aanmelden. Klopt dat niet? Mail ons via ',
                         'Voor dit artikel loopt al een retour, dus je kan het geen tweede keer aanmelden. Klopt dat niet? Mail ons via '],
    eenMinder:          ['Eén minder van '],
    eenMeer:            ['Eén meer van '],
    aantalTerugVoor:    ['Aantal terug van '],
    aantalTerugMax:     [' (maximaal '],

    /* Lopende retour / niets te kiezen */
    lopendTitel:        ['Er loopt al een retour voor deze bestelling'],
    lopendVoor:         ['Voor deze bestelling '],
    lopendMetNummer:    ['loopt al retour '],
    lopendZonderNummer: ['loopt al een retour'],
    lopendOp:           [', aangemeld op '],
    lopendStaart:       ['. Die wordt gewoon verwerkt; je hoeft niets opnieuw aan te melden. '],
    lopendMeer:         [' Wil je nog méér terugsturen of klopt er iets niet? Mail ons via ',
                         ' Wil je nog méér terugsturen of klopt er iets niet? Contacteer ons via '],
    geenArtikelenTitel: ['Geen artikelen om terug te sturen'],
    geenArtikelenTekst: ['Voor deze bestelling staan geen retourneerbare artikelen open. Klopt dat niet? Mail ons via ',
                         'Voor deze bestelling staan geen retourneerbare artikelen open. Klopt dat niet? Contacteer ons via '],
    statusKnop:         ['Bekijk de status of voeg je track & trace-code toe',
                         'Bekijk de status of geef je track & trace-code door'],

    /* Retourredenen */
    redenenLaden:       ['Retourredenen worden geladen…'],
    redenenNiet:        ['We konden de retourredenen niet ophalen.'],
    redenenOpnieuw:     ['Probeer opnieuw'],
    redenenFoutTitel:   ['Retourredenen niet geladen'],
    redenenFoutTekst:   ['De lijst met retourredenen kwam niet binnen.'],

    /* Stap 2 -> 3 */
    kiesArtikelTitel:   ['Kies eerst een artikel'],
    kiesArtikelTekst:   ['Zet met de plusknop het aantal op minstens 1 bij wat je terugstuurt.'],
    kiesRedenTitel:     ['Kies een reden'],
    kiesRedenTekst:     ['Laat ons weten waarom je de artikelen terugstuurt.'],

    /* Samenvatting op stap 3 */
    samBestelling:      ['Bestelling'],
    samArtikel:         ['Artikel'],
    samReden:           ['Reden'],
    samToelichting:     ['Toelichting'],

    /* Aanmelden */
    nietsGekozenTitel:  ['Er is niets geselecteerd', 'Er is niets aangeduid'],
    nietsGekozenTekst:  ['Ga terug en kies wat je terugstuurt.'],
    aanmeldenMisluktTitel: ['Aanmelden is niet gelukt'],
    aanmeldenMisluktTekst: ['Probeer het nog eens. Blijft het misgaan, dan helpen we je graag per mail.',
                         'Probeer het nog eens. Blijft het mislopen, dan helpen we je graag per mail.'],

    /* Klaar-scherm */
    mailBevestigingVoor: ['We hebben een bevestiging met deze instructies gemaild naar '],
    adresOntbreekt:     ['Het retouradres kwam niet mee met het antwoord. Mail ons even, dan sturen we het je toe.',
                         'Het retouradres kwam niet mee met het antwoord. Mail ons even, dan bezorgen we het je.'],
    gekopieerd:         ['Gekopieerd ✓'],
    kopieerFout:        ['Kopiëren lukt niet'],

    /* Track & trace: retour opzoeken */
    tRetourLeegTitel:   ['Vul je retournummer in'],
    tRetourLeegTekst:   ['Dat kreeg je toen je de retour aanmeldde.'],
    tIdentLeegTekst:    ['Daarmee controleren we of de retour van jou is.',
                         'Zo zijn we zeker dat de retour van jou is.'],
    retourWegTitel:     ['We konden deze retour niet vinden'],
    retourWegTekst:     ['Controleer je retournummer en je postcode of e-mailadres.',
                         'Kijk je retournummer en je postcode of e-mailadres even na.'],
    retourGevondenTitel: ['Retour gevonden'],
    retourGevondenTekst: ['Hieronder staan de status en het retouradres.'],
    metaVervoerder:     ['Vervoerder '],
    metaTt:             ['Track & trace '],
    berichtVan:         ['Bericht van Tafelrokkenshop'],
    overgemaaktTitel:   ['Het bedrag is overgemaakt', 'Het bedrag is overgeschreven'],
    overgemaaktTekst:   ['Je terugbetaling is uitgevoerd op dezelfde betaalmethode als waarmee je hebt betaald. Let op: het kan enkele dagen duren voordat het bedrag op je rekening staat; dat hangt af van je bank of betaalmethode.',
                         'Je terugbetaling is uitgevoerd via dezelfde betaalmethode als waarmee je betaald hebt. Hou er rekening mee dat het enkele dagen kan duren voor het bedrag op je rekening staat; dat hangt af van je bank of betaalmethode.'],

    /* Track & trace: code opslaan */
    ttLeegTitel:        ['Vul je track & trace-code in'],
    ttLeegTekst:        ['Die staat op je verzendbewijs of in de mail van de vervoerder.',
                         'Die vind je op je verzendingsbewijs of in de mail van de vervoerder.'],
    ttOpgeslagenTitel:  ['Je code is opgeslagen'],
    ttOpgeslagenTekst:  ['Bedankt, we houden je zending in de gaten. Zodra het pakket binnen is en gecontroleerd, betalen we terug.',
                         'Bedankt, we volgen je zending op. Zodra het pakket toekomt en gecontroleerd is, betalen we terug.'],
    ttOpslaanMisluktTitel: ['Opslaan is niet gelukt'],
    ttOpslaanMisluktTekst: ['Probeer het nog eens.'],

    /* Hints voor ingelogde bezoekers */
    ingelogdHint:       ['Je bent ingelogd, dus dit is meestal niet nodig. Vul het in als het opzoeken niet lukt.'],
    ingelogdHintKort:   ['Je bent ingelogd, dus dit is meestal niet nodig.']
  };

  /* ─── Hulpjes ────────────────────────────────────────────────────────── */

  function el(root, sel) { return root.querySelector(sel); }
  function alle(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function maak(tag, klasse, tekst) {
    var n = document.createElement(tag);
    if (klasse) n.className = klasse;
    if (tekst != null) n.textContent = String(tekst);
    return n;
  }

  function leeg(node) { while (node && node.firstChild) node.removeChild(node.firstChild); }

  /** Eerste niet-lege waarde uit een object, gezocht op een rijtje aliassen. */
  function pak(obj, namen, standaard) {
    if (!obj || typeof obj !== 'object') return standaard;
    for (var i = 0; i < namen.length; i++) {
      var w = obj[namen[i]];
      if (w !== undefined && w !== null && w !== '') return w;
    }
    return standaard;
  }

  /** Query-parameter zonder URLSearchParams: werkt ook in oudere in-app-browsers. */
  function queryParam(naam) {
    var m = new RegExp('[?&]' + naam.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^&#]*)').exec(window.location.search);
    if (!m) return '';
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return m[1]; }
  }

  function getal(waarde, standaard) {
    var n = parseInt(waarde, 10);
    return isNaN(n) ? standaard : n;
  }

  /**
   * Houdt ?stap=track in de adresbalk gelijk aan de modus op het scherm, zonder een
   * history-entry (replaceState). Andere parameters (?retour=, ?postcode=, ?order=)
   * blijven staan. Zo blijft de URL deelbaar en overleeft de modus een herlaad.
   * Zonder history-API doen we niets; de pagina werkt dan gewoon zonder URL-sync.
   */
  function zetUrlStap(track) {
    if (!window.history || typeof window.history.replaceState !== 'function') return;
    var zoek = window.location.search.replace(/^\?/, '');
    var delen = zoek ? zoek.split('&') : [];
    var rest = [];
    for (var i = 0; i < delen.length; i++) {
      if (delen[i] && delen[i].split('=')[0] !== 'stap') rest.push(delen[i]);
    }
    if (track) rest.push('stap=track');
    var nieuw = window.location.pathname + (rest.length ? '?' + rest.join('&') : '') + window.location.hash;
    var huidig = window.location.pathname + window.location.search + window.location.hash;
    if (nieuw === huidig) return;
    try { window.history.replaceState(window.history.state, '', nieuw); } catch (e) { /* strikte browser */ }
  }

  function datumNl(waarde) {
    if (!waarde) return '';
    var d = new Date(waarde);
    if (isNaN(d.getTime())) return String(waarde);
    try {
      return d.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) {
      return String(waarde);
    }
  }

  /* ─── Netwerk ────────────────────────────────────────────────────────── */

  /**
   * Eén verzoekfunctie voor GET en POST. Verwerpt met een Error die drie extra velden
   * kan dragen: `status` (HTTP-code), `melding` (tekst van de server, die is leidend,
   * want de backend geeft bewust generieke meldingen bij 404) en `netwerk` (true als
   * we de server helemaal niet bereikt hebben; dat verdient een ander advies).
   */
  function verzoek(methode, url, body) {
    return new Promise(function (klaar, mislukt) {
      if (typeof window.fetch !== 'function') {
        var oud = new Error('fetch ontbreekt');
        oud.netwerk = true;
        mislukt(oud);
        return;
      }

      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var klok = setTimeout(function () {
        if (controller) controller.abort();
        var traag = new Error('tijdslimiet');
        traag.netwerk = true;
        mislukt(traag);
      }, TIJDSLIMIET);

      var opties = {
        method: methode,
        headers: { Accept: 'application/json' },
        // De app proxy leunt op de sessie van de winkel voor logged_in_customer_id.
        credentials: 'same-origin'
      };
      if (body !== undefined) {
        opties.headers['Content-Type'] = 'application/json';
        opties.body = JSON.stringify(body);
      }
      if (controller) opties.signal = controller.signal;

      window.fetch(url, opties).then(function (res) {
        clearTimeout(klok);
        return res.text().then(function (rauw) {
          var data = null;
          if (rauw) { try { data = JSON.parse(rauw); } catch (e) { data = null; } }

          if (!res.ok) {
            var fout = new Error('status ' + res.status);
            fout.status = res.status;
            fout.melding = data ? pak(data, ['fout', 'melding', 'message', 'error', 'detail'], '') : '';
            if (typeof fout.melding !== 'string') fout.melding = '';
            mislukt(fout);
            return;
          }
          if (data === null) {
            mislukt(new Error('ongeldig antwoord'));
            return;
          }
          klaar(data);
        });
      }, function () {
        clearTimeout(klok);
        var weg = new Error('netwerkfout');
        weg.netwerk = true;
        mislukt(weg);
      });
    });
  }

  /* ─── Sectie ─────────────────────────────────────────────────────────── */

  function init(root) {
    if (root.dataset.rtKlaar === '1') return;
    root.dataset.rtKlaar = '1';

    var cfg = {};
    var cfgEl = el(root, '.rt26-config');
    if (cfgEl) { try { cfg = JSON.parse(cfgEl.textContent) || {}; } catch (e) { cfg = {}; } }

    var BASIS = String(cfg.basis || '/apps/zakelijk/retour').replace(/\/+$/, '');
    var INGELOGD = cfg.ingelogd === true;
    var DAGEN = getal(cfg.dagen, 14);
    var EMAIL = String(cfg.email || '');
    var REGIO = String(cfg.regio || 'nl').toLowerCase();

    /** Tekst uit TEKSTEN, Vlaams op .be en anders Nederlands. */
    function t(sleutel) {
      var paar = TEKSTEN[sleutel];
      if (!paar) return '';
      if (REGIO === 'be' && paar.length > 1 && paar[1]) return paar[1];
      return paar[0];
    }

    var dom = {
      wizard: el(root, '.rt26-wizard'),
      voortgang: el(root, '[data-voortgang]'),
      panelen: alle(root, '[data-stap]'),

      formZoek: el(root, '[data-form="zoek"]'),
      vOrdernummer: el(root, '[data-veld="ordernummer"]'),
      vIdentificatie: el(root, '[data-veld="identificatie"]'),
      wrapIdentificatie: el(root, '[data-veld-wrap="identificatie"]'),

      orderkop: el(root, '[data-orderkop]'),
      regelsLijst: el(root, '[data-regels]'),
      formRegels: el(root, '[data-form="regels"]'),
      vReden: el(root, '[data-veld="reden"]'),
      redenenHint: el(root, '[data-redenen-hint]'),
      vOpmerking: el(root, '[data-veld="opmerking"]'),

      samenvatting: el(root, '[data-samenvatting]'),
      knopBevestig: el(root, '[data-knop="bevestig"]'),

      retournummer: el(root, '[data-retournummer]'),
      retouradres: el(root, '[data-retouradres]'),
      instructies: el(root, '[data-instructies]'),
      knopKopieer: el(root, '[data-kopieer]'),
      ovvNummer: el(root, '[data-ovv-nummer]'),
      tovvNummer: el(root, '[data-tovv-nummer]'),
      tverzend: el(root, '[data-tverzend]'),
      knopPrints: alle(root, '[data-print]'),
      printRetour2: el(root, '[data-print-retour2]'),
      printAdres: el(root, '[data-print-adres]'),

      formTzoek: el(root, '[data-form="tzoek"]'),
      vTretournummer: el(root, '[data-veld="tretournummer"]'),
      vTidentificatie: el(root, '[data-veld="tidentificatie"]'),
      wrapTidentificatie: el(root, '[data-veld-wrap="tidentificatie"]'),
      tresultaat: el(root, '[data-tresultaat]'),
      tsamenvatting: el(root, '[data-tsamenvatting]'),
      tretouradres: el(root, '[data-tretouradres]'),
      formTcode: el(root, '[data-form="tcode"]'),
      vTtcode: el(root, '[data-veld="ttcode"]'),
      vTtvervoerder: el(root, '[data-veld="ttvervoerder"]'),
      vTtanders: el(root, '[data-veld="ttanders"]'),
      wrapTtanders: el(root, '[data-veld-wrap="ttanders"]')
    };

    var staat = {
      ordernummer: '',
      identificatie: '',
      order: null,
      regels: [],
      redenen: [],
      redenenGeladen: false,
      redenCode: '',
      redenLabel: '',
      opmerking: '',
      retour: null,
      trackRetournummer: '',
      trackIdentificatie: '',
      // Laatst getoonde wizardstap ('1' t/m '4'): wie vanuit stap 2 even de status
      // bekijkt en terugschakelt, komt terug waar hij was, niet weer bij stap 1.
      wizardStap: '1',
      bezig: false
    };

    /* ── Meldingen ─────────────────────────────────────────────────────── */

    /**
     * @param naam   sleutel van het meldingsvak (data-melding="…")
     * @param soort  'err' | 'ok' | 'info' | '' (leeg = melding wissen)
     * @param titel  vetgedrukte eerste regel, mag leeg
     * @param tekst  lopende tekst, of een array van strings/DOM-knopen
     */
    function melding(naam, soort, titel, tekst) {
      var vak = el(root, '[data-melding="' + naam + '"]');
      if (!vak) return;
      leeg(vak);
      vak.className = 'rt26-melding';
      if (!soort) return;
      vak.className = 'rt26-melding rt26-melding--' + soort;
      if (titel) vak.appendChild(maak('strong', null, titel));
      var delen = Object.prototype.toString.call(tekst) === '[object Array]' ? tekst : [tekst];
      delen.forEach(function (d) {
        if (d == null || d === '') return;
        vak.appendChild(typeof d === 'string' ? document.createTextNode(d) : d);
      });
    }

    function mailLink(voorvoegsel) {
      var span = document.createElement('span');
      if (voorvoegsel) span.appendChild(document.createTextNode(voorvoegsel));
      var a = maak('a', null, EMAIL);
      a.href = 'mailto:' + EMAIL;
      span.appendChild(a);
      span.appendChild(document.createTextNode('.'));
      return span;
    }

    /** Netwerkfout, tijdslimiet en 5xx krijgen bewust hetzelfde advies: nog eens proberen. */
    function toonFout(naam, e, standaardTitel, standaardTekst) {
      if (e && e.netwerk) {
        melding(naam, 'err', t('netwerkTitel'), [t('netwerkTekst'), mailLink('')]);
        return;
      }
      if (e && e.status === 429) {
        melding(naam, 'err', t('rustigTitel'), t('rustigTekst'));
        return;
      }
      if (e && e.melding) {
        melding(naam, 'err', standaardTitel, e.melding);
        return;
      }
      if (e && e.status >= 500) {
        melding(naam, 'err', t('serverTitel'), [t('serverTekst'), mailLink('')]);
        return;
      }
      melding(naam, 'err', standaardTitel, standaardTekst);
    }

    /* ── Knoppen ───────────────────────────────────────────────────────── */

    /** Zet een knop in de wachtstand. Blokkeert ook alle andere knoppen: één verzoek tegelijk. */
    function bezigZet(knop, aan, wachttekst) {
      staat.bezig = aan;
      if (knop) {
        if (aan) {
          if (!knop.dataset.rustTekst) knop.dataset.rustTekst = knop.textContent;
          knop.textContent = wachttekst || t('bezig');
        } else if (knop.dataset.rustTekst) {
          knop.textContent = knop.dataset.rustTekst;
        }
        knop.setAttribute('aria-busy', aan ? 'true' : 'false');
      }
      alle(root, '.rt26-btn, .rt26-btn-ghost').forEach(function (b) {
        // <a class="rt26-btn"> is een echte link (contactpagina), die blijft altijd bruikbaar.
        if (b.tagName === 'BUTTON') b.disabled = aan;
      });
    }

    /* ── Stappen ───────────────────────────────────────────────────────── */

    var VOLGORDE = { '1': 1, '2': 2, '3': 3, '4': 4 };
    var modusKnoppen = alle(root, '[data-modus]');

    /** Keuzeblok bovenaan: markeer de actieve modus ('aanmelden' of 'track'). */
    function zetModus(modus) {
      modusKnoppen.forEach(function (k) {
        k.setAttribute('aria-pressed', k.getAttribute('data-modus') === modus ? 'true' : 'false');
      });
    }

    function stapNaar(naam, scroll) {
      dom.panelen.forEach(function (p) { p.hidden = p.dataset.stap !== naam; });

      var nr = VOLGORDE[naam] || 0;
      // Modus bijhouden: alles behalve 'track' hoort bij de aanmeld-wizard (ook het
      // termijn-paneel; daarvandaan terugschakelen begint gewoon weer bij stap 1).
      var isTrack = naam === 'track';
      if (nr > 0) staat.wizardStap = naam;
      else if (!isTrack) staat.wizardStap = '1';
      zetModus(isTrack ? 'track' : 'aanmelden');
      zetUrlStap(isTrack);
      if (dom.voortgang) {
        dom.voortgang.hidden = nr === 0;
        alle(dom.voortgang, '[data-vstap]').forEach(function (li) {
          var eigen = getal(li.getAttribute('data-vstap'), 0);
          if (eigen === nr) {
            li.setAttribute('data-actief', '1');
            li.setAttribute('aria-current', 'step');
          } else {
            li.removeAttribute('data-actief');
            li.removeAttribute('aria-current');
          }
          if (eigen < nr) li.setAttribute('data-gedaan', '1');
          else li.removeAttribute('data-gedaan');
        });
      }

      var paneel = null;
      for (var i = 0; i < dom.panelen.length; i++) {
        if (dom.panelen[i].dataset.stap === naam) { paneel = dom.panelen[i]; break; }
      }
      if (!paneel) return;

      // a11y: de focus verhuist naar de kop van de nieuwe stap, anders staat een
      // schermlezer- of toetsenbordgebruiker nog bij de knop die net verdween.
      var kop = el(paneel, '[tabindex="-1"]');
      if (kop) {
        try { kop.focus({ preventScroll: true }); } catch (e) { kop.focus(); }
      }
      if (scroll !== false && dom.wizard && dom.wizard.scrollIntoView) {
        dom.wizard.scrollIntoView({ block: 'start' });
      }
    }

    alle(root, '[data-naar]').forEach(function (knop) {
      knop.addEventListener('click', function () {
        if (staat.bezig) return;
        var doel = knop.getAttribute('data-naar');
        if (doel === 'track') vulTrackVoorin();
        stapNaar(doel, true);
      });
    });

    // Keuzeblok: wisselen tussen aanmelden en status/track & trace. Geen scroll: de
    // knoppen staan al bovenaan de wizard, het paneel eronder wisselt gewoon.
    modusKnoppen.forEach(function (knop) {
      knop.addEventListener('click', function () {
        if (staat.bezig) return;
        var doel = knop.getAttribute('data-modus');
        if (doel === 'track') {
          vulTrackVoorin();
          stapNaar('track', false);
        } else {
          stapNaar(staat.wizardStap || '1', false);
        }
      });
    });

    /* ── Stap 1: bestelling opzoeken ───────────────────────────────────── */

    function veldFout(veld, aan) {
      if (!veld) return;
      var wrap = veld.closest ? veld.closest('.rt26-veld') : null;
      if (wrap) wrap.classList.toggle('rt26-veldfout', !!aan);
      veld.setAttribute('aria-invalid', aan ? 'true' : 'false');
    }

    function identificatieZichtbaar() {
      return dom.wrapIdentificatie ? !dom.wrapIdentificatie.hidden : true;
    }

    function toonIdentificatie() {
      if (dom.wrapIdentificatie) dom.wrapIdentificatie.hidden = false;
    }

    if (dom.formZoek) {
      dom.formZoek.addEventListener('submit', function (e) {
        e.preventDefault();
        if (staat.bezig) return;
        zoekOrder();
      });
    }

    function zoekOrder() {
      var ordernummer = (dom.vOrdernummer.value || '').trim();
      var identificatie = dom.vIdentificatie ? (dom.vIdentificatie.value || '').trim() : '';

      veldFout(dom.vOrdernummer, false);
      veldFout(dom.vIdentificatie, false);

      if (!ordernummer) {
        veldFout(dom.vOrdernummer, true);
        melding('zoek', 'err', t('ordernummerLeegTitel'), t('ordernummerLeegTekst'));
        dom.vOrdernummer.focus();
        return;
      }
      // Ingelogd herkent de proxy de klant zelf; als gast is postcode of e-mail verplicht.
      if (!INGELOGD && !identificatie) {
        veldFout(dom.vIdentificatie, true);
        melding('zoek', 'err', t('identLeegTitel'), t('identLeegTekst'));
        dom.vIdentificatie.focus();
        return;
      }

      var body = { ordernummer: ordernummer };
      if (identificatie) body.postcodeOfEmail = identificatie;

      var knop = el(root, '[data-knop="zoek"]');
      melding('zoek', '', '', '');
      bezigZet(knop, true, t('bezigZoeken'));

      verzoek('POST', BASIS + '/order-opzoeken', body).then(function (data) {
        bezigZet(knop, false);
        staat.ordernummer = ordernummer;
        staat.identificatie = identificatie;
        verwerkOrder(data);
      }, function (e) {
        bezigZet(knop, false);
        if (e && e.status === 404) {
          // Bewust geen onderscheid tussen "bestaat niet" en "gegevens kloppen niet",
          // dat onderscheid zou het bruteforcen van ordernummers makkelijker maken.
          var extra = null;
          if (!identificatieZichtbaar()) {
            toonIdentificatie();
            extra = t('orderWegExtra');
          }
          melding('zoek', 'err', t('orderWegTitel'), [(e.melding || t('orderWegTekst')), extra]);
          return;
        }
        toonFout('zoek', e, t('opzoekenMisluktTitel'), t('opzoekenMisluktTekst'));
      });
    }

    function verwerkOrder(data) {
      // Het contract omhult de order: { order: { … } }. Zonder uitpakken leest
      // alles hieronder het buitenste object en lijkt élke bestelling leeg:
      // nul regels, geen besteldatum. (Zo live gevonden op 2026-08-14.)
      if (data && typeof data === 'object' && data.order && typeof data.order === 'object') {
        data = data.order;
      }
      staat.order = data;
      staat.lopendeRetour = pak(data, ['lopendeRetour', 'openRetour', 'lopende_retour'], null);

      var binnen = pak(data, ['binnenTermijn', 'binnen_termijn', 'withinReturnWindow', 'inTermijn'], true);
      if (binnen === false || binnen === 'false') {
        stapNaar('termijn', true);
        return;
      }

      var rauweRegels = pak(data, ['regels', 'orderRegels', 'lines', 'lineItems', 'items'], []);
      if (!rauweRegels || typeof rauweRegels.length !== 'number') rauweRegels = [];

      staat.regels = [];
      for (var i = 0; i < rauweRegels.length; i++) {
        var r = rauweRegels[i];
        if (!r || typeof r !== 'object') continue;
        var besteld = getal(pak(r, ['aantal', 'quantity', 'aantalBesteld'], 0), 0);
        var max = getal(pak(r, ['maxAantal', 'retourneerbaar', 'retourneerbaarAantal'], besteld), besteld);
        if (max > besteld && besteld > 0) max = besteld;
        var geblokkeerd = pak(r, ['alReedsRetour', 'alRetour', 'reedsRetour', 'alreadyReturned'], false) === true;
        staat.regels.push({
          regelId: String(pak(r, ['regelId', 'id', 'lineItemId', 'lineId'], '')),
          titel: String(pak(r, ['titel', 'title', 'naam', 'name'], 'Artikel')),
          variant: String(pak(r, ['variant', 'variantTitel', 'variantTitle', 'omschrijving'], '')),
          besteld: besteld,
          max: geblokkeerd ? 0 : Math.max(0, max),
          geblokkeerd: geblokkeerd,
          aantal: 0
        });
      }

      tekenOrderkop(data);
      tekenRegels();
      laadRedenen();
      melding('regels', '', '', '');
      zetRegelsFormulier(true);

      var selecteerbaar = false;
      for (var s = 0; s < staat.regels.length; s++) {
        if (!staat.regels[s].geblokkeerd && staat.regels[s].max > 0) { selecteerbaar = true; break; }
      }

      if (!selecteerbaar) {
        // Niets te kiezen: verberg reden/toelichting/verder-knop, anders staat er
        // een formulier dat nergens toe leidt. En leg uit wáárom er niets kan.
        zetRegelsFormulier(false);
        var lopend = staat.lopendeRetour;
        if (lopend && typeof lopend === 'object') {
          var nr = String(pak(lopend, ['retournummer', 'returnNo', 'nummer'], ''));
          var op = datumNl(pak(lopend, ['aangemeldOp', 'createdAt', 'datum'], ''));
          var delen = [t('lopendVoor') +
            (nr ? t('lopendMetNummer') + nr : t('lopendZonderNummer')) +
            (op ? t('lopendOp') + op : '') +
            t('lopendStaart')];
          delen.push(trackKnop(nr));
          delen.push(t('lopendMeer'));
          delen.push(mailLink(''));
          melding('regels', 'info', t('lopendTitel'), delen);
        } else {
          melding('regels', 'info', t('geenArtikelenTitel'), [t('geenArtikelenTekst'), mailLink('')]);
        }
      }

      stapNaar('2', true);
    }

    /** Reden, toelichting en de verder-knop tonen of verbergen (de terug-knop blijft). */
    function zetRegelsFormulier(aan) {
      var reden = dom.vReden && dom.vReden.parentNode;
      var opmerking = el(root, '[data-veld="opmerking"]');
      var opmerkingWrap = opmerking && opmerking.parentNode;
      var verder = el(root, '[data-knop="regels"]');
      if (reden) reden.hidden = !aan;
      if (opmerkingWrap) opmerkingWrap.hidden = !aan;
      if (verder) verder.hidden = !aan;
    }

    /**
     * Knop naar de track & trace-modus, met retournummer en identificatie voorgevuld.
     * Kennen we allebei (of is de bezoeker ingelogd), dan zoeken we de retour meteen
     * op: de klant ziet dan direct de status, met het T&T-veld eronder.
     */
    function trackKnop(retournummer) {
      var knop = maak('button', 'rt26-link', t('statusKnop'));
      knop.type = 'button';
      knop.addEventListener('click', function () {
        if (retournummer && dom.vTretournummer) dom.vTretournummer.value = retournummer;
        if (staat.identificatie && dom.vTidentificatie) dom.vTidentificatie.value = staat.identificatie;
        stapNaar('track', true);
        if (retournummer && (staat.identificatie || INGELOGD)) dienTzoekIn();
      });
      return knop;
    }

    /** Dient het retour-opzoekformulier programmatisch in (zelfde pad als een echte submit). */
    function dienTzoekIn() {
      var f = el(root, '[data-form="tzoek"]');
      if (!f) return;
      try {
        var ev;
        try { ev = new Event('submit', { cancelable: true, bubbles: true }); }
        catch (e2) { ev = document.createEvent('Event'); ev.initEvent('submit', true, true); }
        f.dispatchEvent(ev);
      } catch (e3) { /* dan zoekt de bezoeker handmatig */ }
    }

    function tekenOrderkop(data) {
      if (!dom.orderkop) return;
      leeg(dom.orderkop);
      var nummer = String(pak(data, ['ordernummer', 'orderNumber', 'name', 'nummer'], staat.ordernummer));
      dom.orderkop.appendChild(maak('strong', null, t('bestellingVoor') + nummer));
      var datum = datumNl(pak(data, ['besteldatum', 'orderDatum', 'orderDate', 'createdAt', 'geplaatstOp'], ''));
      var termijn = t('termijnVoor') + DAGEN + t('termijnNa');
      var regel = datum ? t('besteldOp') + datum + '. ' + termijn : termijn;
      dom.orderkop.appendChild(document.createTextNode(regel));
    }

    /* ── Stap 2: artikelen en reden ────────────────────────────────────── */

    function tekenRegels() {
      if (!dom.regelsLijst) return;
      leeg(dom.regelsLijst);

      staat.regels.forEach(function (r, index) {
        var li = maak('li', 'rt26-regel');
        if (r.geblokkeerd) li.className += ' rt26-regel--geblokkeerd';

        var info = document.createElement('div');
        info.appendChild(maak('div', 'rt26-regel-t', r.titel));

        var subdelen = [];
        if (r.variant && r.variant !== r.titel) subdelen.push(r.variant);
        subdelen.push(r.besteld + (r.besteld === 1 ? t('stukBesteld') : t('stuksBesteld')));
        info.appendChild(maak('div', 'rt26-regel-s', subdelen.join(' · ')));
        li.appendChild(info);

        if (r.geblokkeerd) {
          var uitleg = maak('p', 'rt26-regel-uitleg', t('regelGeblokkeerd'));
          uitleg.appendChild(mailLink(''));
          uitleg.style.margin = '0';
          li.appendChild(uitleg);
          dom.regelsLijst.appendChild(li);
          return;
        }

        var stepper = maak('div', 'rt26-stepper');
        var min = maak('button', null, '−');
        min.type = 'button';
        min.setAttribute('aria-label', t('eenMinder') + r.titel);
        var invoer = document.createElement('input');
        invoer.type = 'number';
        invoer.min = '0';
        invoer.max = String(r.max);
        invoer.step = '1';
        invoer.value = '0';
        invoer.setAttribute('inputmode', 'numeric');
        invoer.setAttribute('aria-label', t('aantalTerugVoor') + r.titel + t('aantalTerugMax') + r.max + ')');
        var plus = maak('button', null, '+');
        plus.type = 'button';
        plus.setAttribute('aria-label', t('eenMeer') + r.titel);

        function zet(nieuw) {
          var n = Math.max(0, Math.min(r.max, getal(nieuw, 0)));
          r.aantal = n;
          invoer.value = String(n);
          min.disabled = n <= 0;
          plus.disabled = n >= r.max;
          li.classList.toggle('rt26-regel--gekozen', n > 0);
          staat.regels[index].aantal = n;
        }

        min.addEventListener('click', function () { zet(r.aantal - 1); });
        plus.addEventListener('click', function () { zet(r.aantal + 1); });
        invoer.addEventListener('change', function () { zet(invoer.value); });
        invoer.addEventListener('blur', function () { zet(invoer.value); });

        stepper.appendChild(min);
        stepper.appendChild(invoer);
        stepper.appendChild(plus);
        li.appendChild(stepper);
        dom.regelsLijst.appendChild(li);

        zet(0);
      });
    }

    function laadRedenen() {
      if (staat.redenenGeladen || !dom.vReden) return;

      if (dom.redenenHint) dom.redenenHint.textContent = t('redenenLaden');

      verzoek('GET', BASIS + '/redenen').then(function (data) {
        var lijst = data;
        if (!lijst || typeof lijst.length !== 'number') {
          lijst = pak(data, ['redenen', 'reasons', 'data', 'items'], []);
        }
        if (!lijst || typeof lijst.length !== 'number') lijst = [];

        staat.redenen = [];
        for (var i = 0; i < lijst.length; i++) {
          var x = lijst[i];
          if (!x) continue;
          if (typeof x === 'string') { staat.redenen.push({ code: x, label: x }); continue; }
          var code = String(pak(x, ['code', 'id', 'value', 'waarde'], ''));
          var label = String(pak(x, ['label', 'omschrijving', 'naam', 'name', 'titel'], code));
          if (code) staat.redenen.push({ code: code, label: label });
        }

        // Selectie behouden zou hier niets toevoegen: de lijst is net pas geladen.
        while (dom.vReden.options.length > 1) dom.vReden.remove(1);
        staat.redenen.forEach(function (r) {
          var opt = document.createElement('option');
          opt.value = r.code;
          opt.textContent = r.label;
          dom.vReden.appendChild(opt);
        });

        staat.redenenGeladen = staat.redenen.length > 0;
        if (dom.redenenHint) {
          dom.redenenHint.textContent = staat.redenenGeladen ? '' : t('redenenNiet');
        }
        if (!staat.redenenGeladen) toonRedenenFout(null);
      }, function (e) {
        if (dom.redenenHint) dom.redenenHint.textContent = '';
        toonRedenenFout(e);
      });
    }

    /** Zonder redenen kan de retour niet aangemeld worden; dus een knop om het opnieuw te proberen. */
    function toonRedenenFout(e) {
      var opnieuw = maak('button', 'rt26-link', t('redenenOpnieuw'));
      opnieuw.type = 'button';
      opnieuw.addEventListener('click', function () {
        melding('regels', '', '', '');
        staat.redenenGeladen = false;
        laadRedenen();
      });
      var tekst = (e && e.melding) ? e.melding : t('redenenFoutTekst');
      melding('regels', 'err', t('redenenFoutTitel'), [tekst + ' ', opnieuw]);
    }

    if (dom.formRegels) {
      dom.formRegels.addEventListener('submit', function (e) {
        e.preventDefault();
        if (staat.bezig) return;
        naarBevestigen();
      });
    }

    function gekozenRegels() {
      return staat.regels.filter(function (r) { return !r.geblokkeerd && r.aantal > 0; });
    }

    function naarBevestigen() {
      var gekozen = gekozenRegels();
      veldFout(dom.vReden, false);

      if (!gekozen.length) {
        melding('regels', 'err', t('kiesArtikelTitel'), t('kiesArtikelTekst'));
        return;
      }
      var reden = dom.vReden ? dom.vReden.value : '';
      if (!reden) {
        veldFout(dom.vReden, true);
        melding('regels', 'err', t('kiesRedenTitel'), t('kiesRedenTekst'));
        if (dom.vReden) dom.vReden.focus();
        return;
      }

      staat.redenCode = reden;
      staat.redenLabel = dom.vReden.options[dom.vReden.selectedIndex]
        ? dom.vReden.options[dom.vReden.selectedIndex].textContent
        : reden;
      staat.opmerking = dom.vOpmerking ? (dom.vOpmerking.value || '').trim() : '';

      melding('regels', '', '', '');
      melding('bevestig', '', '', '');
      tekenSamenvatting(gekozen);
      stapNaar('3', true);
    }

    /* ── Stap 3: bevestigen ────────────────────────────────────────────── */

    function samenvattingRegel(lijst, kop, waarde, vrij) {
      var li = document.createElement('li');
      li.appendChild(maak('span', 'rt26-sam-k', kop));
      li.appendChild(maak('span', vrij ? 'rt26-sam-v rt26-sam-vrij' : 'rt26-sam-v', waarde));
      lijst.appendChild(li);
    }

    function tekenSamenvatting(gekozen) {
      if (!dom.samenvatting) return;
      leeg(dom.samenvatting);

      samenvattingRegel(dom.samenvatting, t('samBestelling'), staat.ordernummer);
      gekozen.forEach(function (r) {
        var naam = r.variant && r.variant !== r.titel ? r.titel + ' (' + r.variant + ')' : r.titel;
        samenvattingRegel(dom.samenvatting, t('samArtikel'), r.aantal + '× ' + naam);
      });
      samenvattingRegel(dom.samenvatting, t('samReden'), staat.redenLabel);
      if (staat.opmerking) samenvattingRegel(dom.samenvatting, t('samToelichting'), staat.opmerking, true);
    }

    if (dom.knopBevestig) {
      dom.knopBevestig.addEventListener('click', function () {
        if (staat.bezig) return;
        meldAan();
      });
    }

    function meldAan() {
      var gekozen = gekozenRegels();
      if (!gekozen.length) {
        melding('bevestig', 'err', t('nietsGekozenTitel'), t('nietsGekozenTekst'));
        return;
      }

      var body = {
        ordernummer: staat.ordernummer,
        regels: gekozen.map(function (r) { return { regelId: r.regelId, aantal: r.aantal }; }),
        redenCode: staat.redenCode
      };
      if (staat.identificatie) body.postcodeOfEmail = staat.identificatie;
      if (staat.opmerking) body.opmerking = staat.opmerking;

      melding('bevestig', '', '', '');
      bezigZet(dom.knopBevestig, true, t('bezigAanmelden'));

      verzoek('POST', BASIS + '/aanmelden', body).then(function (data) {
        bezigZet(dom.knopBevestig, false);
        staat.retour = data;
        vulKlaarScherm(data);
        stapNaar('4', true);
      }, function (e) {
        bezigZet(dom.knopBevestig, false);
        toonFout('bevestig', e, t('aanmeldenMisluktTitel'), t('aanmeldenMisluktTekst'));
      });
    }

    /* ── Stap 4: klaar-scherm ──────────────────────────────────────────── */

    /** Retouradres komt als string, array of object binnen, alle drie zijn bruikbaar. */
    function adresRegels(waarde) {
      if (!waarde) return [];
      if (typeof waarde === 'string') {
        return waarde.split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean);
      }
      if (typeof waarde.length === 'number') {
        return Array.prototype.slice.call(waarde).map(function (s) { return String(s).trim(); }).filter(Boolean);
      }
      if (typeof waarde === 'object') {
        var regels = [];
        function voeg(w) { if (w) regels.push(String(w).trim()); }
        voeg(pak(waarde, ['naam', 'name', 'bedrijf', 'company'], ''));
        voeg(pak(waarde, ['tav', 'attentie'], ''));
        voeg(pak(waarde, ['straat', 'street', 'adres', 'address', 'address1', 'adresregel1'], ''));
        voeg(pak(waarde, ['adres2', 'address2', 'adresregel2', 'toevoeging'], ''));
        var pc = pak(waarde, ['postcode', 'zip', 'postalCode'], '');
        var plaats = pak(waarde, ['plaats', 'stad', 'city'], '');
        if (pc || plaats) regels.push((String(pc || '').trim() + ' ' + String(plaats || '').trim()).trim());
        voeg(pak(waarde, ['land', 'country'], ''));
        return regels.filter(Boolean);
      }
      return [];
    }

    function vulKlaarScherm(data) {
      var nummer = String(pak(data, ['retournummer', 'returnNumber', 'nummer', 'rma'], ''));
      if (dom.retournummer) dom.retournummer.textContent = nummer || '-';
      if (dom.ovvNummer) dom.ovvNummer.textContent = nummer || '-';

      // Bevestigingsmail: de backend meldt naar welk adres er gemaild is (of null
      // als dat niet kon). Alleen tonen als het echt gelukt is.
      var mailNaar = pak(data, ['bevestigingsmailNaar', 'confirmationEmailTo'], '');
      var mailEl = el(root, '[data-mailmelding]');
      if (mailEl) {
        if (mailNaar) {
          mailEl.textContent = t('mailBevestigingVoor') + mailNaar + '.';
          mailEl.hidden = false;
        } else {
          mailEl.hidden = true;
        }
      }

      // Adreslabel voor de printknop: adres + retournummer.
      if (dom.printRetour2) dom.printRetour2.textContent = nummer || '-';

      var regels = adresRegels(pak(data, ['retouradres', 'returnAddress', 'adres'], ''));
      if (dom.printAdres) {
        leeg(dom.printAdres);
        regels.forEach(function (r) { dom.printAdres.appendChild(maak('span', null, r)); });
      }

      if (dom.retouradres) {
        leeg(dom.retouradres);
        if (regels.length) {
          regels.forEach(function (r) { dom.retouradres.appendChild(maak('span', null, r)); });
        } else {
          dom.retouradres.appendChild(maak('span', null, t('adresOntbreekt')));
        }
      }

      if (dom.instructies) {
        leeg(dom.instructies);
        var instr = pak(data, ['instructies', 'instructions', 'toelichting'], '');
        var stukken = [];
        if (typeof instr === 'string' && instr.trim()) stukken = instr.split(/\r?\n/).filter(function (s) { return s.trim(); });
        else if (instr && typeof instr.length === 'number') stukken = Array.prototype.slice.call(instr);
        if (stukken.length) {
          dom.instructies.hidden = false;
          stukken.forEach(function (s, i) {
            var p = maak('p', null, String(s).trim());
            p.style.margin = i === 0 ? '0' : '8px 0 0';
            dom.instructies.appendChild(p);
          });
        } else {
          dom.instructies.hidden = true;
        }
      }

      // Alvast klaarzetten voor de T&T-modus, zodat de bezoeker niets hoeft over te typen.
      staat.trackRetournummer = nummer;
      staat.trackIdentificatie = staat.identificatie;
    }

    // Eén printvel, twee knoppen: op het klaar-scherm en op de statuspagina.
    var printblad = el(root, '[data-printblad]');
    var printDatum = el(root, '[data-print-datum]');

    dom.knopPrints.forEach(function (knop) {
      knop.addEventListener('click', function () {
        // Datum en tijd op het label, kaal en vers per afdruk.
        if (printDatum) {
          var nu = new Date();
          var tijd;
          try {
            tijd = nu.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
          } catch (eT) {
            tijd = nu.getHours() + ':' + ('0' + nu.getMinutes()).slice(-2);
          }
          printDatum.textContent = datumNl(nu) + ', ' + tijd;
        }

        // Het label gaat tijdens de afdruk direct onder <body>, zodat de print-CSS
        // ál het andere met display:none kan laten verdwijnen (geen lege pagina's).
        // De A6-regel bestaat alleen tijdens deze afdruk; een gewone paginaprint
        // blijft daardoor op A4.
        var oudePlek = printblad ? printblad.parentNode : null;
        if (printblad) document.body.appendChild(printblad);
        var a6 = document.createElement('style');
        a6.textContent = '@media print { @page { size: A6 portrait; margin: 4mm; } }';
        document.head.appendChild(a6);
        document.body.classList.add('rt26-print');

        var klaar = function () {
          document.body.classList.remove('rt26-print');
          if (a6.parentNode) a6.parentNode.removeChild(a6);
          if (printblad && oudePlek) oudePlek.appendChild(printblad);
          window.removeEventListener('afterprint', klaar);
        };
        window.addEventListener('afterprint', klaar);
        try { window.print(); } catch (e) { /* print niet beschikbaar */ }
        setTimeout(klaar, 3000);
      });
    });

    if (dom.knopKopieer) {
      // aria-live op de knop zelf: de knoptekst wisselt naar "Gekopieerd", en dat is
      // precies de terugkoppeling die een schermlezer moet horen.
      dom.knopKopieer.setAttribute('aria-live', 'polite');
      dom.knopKopieer.addEventListener('click', function () {
        var tekst = dom.retournummer ? dom.retournummer.textContent : '';
        if (!tekst || tekst === '-') return;
        kopieer(tekst).then(function () { bevestigKopie(t('gekopieerd')); },
          function () { bevestigKopie(t('kopieerFout')); });
      });
    }

    function kopieer(tekst) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(tekst);
      }
      // Terugval voor browsers zonder Clipboard API (o.a. oudere in-app-browsers).
      return new Promise(function (klaar, mislukt) {
        var hulp = document.createElement('textarea');
        hulp.value = tekst;
        hulp.setAttribute('readonly', 'readonly');
        hulp.style.cssText = 'position:absolute;left:-9999px;top:0;';
        document.body.appendChild(hulp);
        hulp.select();
        var gelukt = false;
        try { gelukt = document.execCommand('copy'); } catch (e) { gelukt = false; }
        document.body.removeChild(hulp);
        gelukt ? klaar() : mislukt(new Error('kopiëren mislukt'));
      });
    }

    var kopieerKlok = null;
    function bevestigKopie(tekst) {
      if (!dom.knopKopieer) return;
      if (!dom.knopKopieer.dataset.rustTekst2) dom.knopKopieer.dataset.rustTekst2 = dom.knopKopieer.textContent;
      dom.knopKopieer.textContent = tekst;
      clearTimeout(kopieerKlok);
      kopieerKlok = setTimeout(function () {
        dom.knopKopieer.textContent = dom.knopKopieer.dataset.rustTekst2;
      }, 2500);
    }

    /* ── Track & trace ─────────────────────────────────────────────────── */

    function vulTrackVoorin() {
      if (dom.vTretournummer && !dom.vTretournummer.value && staat.trackRetournummer) {
        dom.vTretournummer.value = staat.trackRetournummer;
      }
      if (dom.vTidentificatie && !dom.vTidentificatie.value && staat.trackIdentificatie) {
        dom.vTidentificatie.value = staat.trackIdentificatie;
      }
    }

    if (dom.formTzoek) {
      dom.formTzoek.addEventListener('submit', function (e) {
        e.preventDefault();
        if (staat.bezig) return;
        zoekRetour();
      });
    }

    /**
     * `stil` = achtergrondverversing (na het opslaan van een T&T-code): geen
     * meldingen aanraken, alleen de samenvatting opnieuw tekenen.
     */
    function zoekRetour(stil) {
      var nummer = (dom.vTretournummer.value || '').trim();
      var identificatie = dom.vTidentificatie ? (dom.vTidentificatie.value || '').trim() : '';

      veldFout(dom.vTretournummer, false);
      veldFout(dom.vTidentificatie, false);

      if (!nummer) {
        veldFout(dom.vTretournummer, true);
        melding('tzoek', 'err', t('tRetourLeegTitel'), t('tRetourLeegTekst'));
        dom.vTretournummer.focus();
        return;
      }
      if (!INGELOGD && !identificatie) {
        veldFout(dom.vTidentificatie, true);
        melding('tzoek', 'err', t('identLeegTitel'), t('tIdentLeegTekst'));
        dom.vTidentificatie.focus();
        return;
      }

      var body = { retournummer: nummer };
      if (identificatie) body.postcodeOfEmail = identificatie;

      var knop = el(root, '[data-knop="tzoek"]');
      if (!stil) {
        melding('tzoek', '', '', '');
        melding('tcode', '', '', '');
      }
      bezigZet(knop, true, t('bezigZoeken'));

      // Zonder `trackAndTrace` in de body geeft dezelfde route alleen status en adres terug.
      verzoek('POST', BASIS + '/track-en-trace', body).then(function (data) {
        bezigZet(knop, false);
        staat.trackRetournummer = nummer;
        staat.trackIdentificatie = identificatie;
        toonRetour(data, nummer, stil);
      }, function (e) {
        bezigZet(knop, false);
        if (stil) return; // achtergrondverversing: stil falen, de melding staat er al
        if (dom.tresultaat) dom.tresultaat.hidden = true;
        if (e && e.status === 404) {
          melding('tzoek', 'err', t('retourWegTitel'), e.melding || t('retourWegTekst'));
          return;
        }
        toonFout('tzoek', e, t('opzoekenMisluktTitel'), t('opzoekenMisluktTekst'));
      });
    }

    function toonRetour(data, nummer, stil) {
      var retournr = String(pak(data, ['retournummer', 'returnNumber', 'nummer'], nummer));
      var ordernr = String(pak(data, ['ordernummer', 'orderNumber', 'orderNo'], '') || staat.ordernummer || '');
      var bestaandeTt = pak(data, ['trackAndTrace', 'trackandtrace', 'tt'], '');

      if (dom.tsamenvatting) {
        leeg(dom.tsamenvatting);

        // Compact: retournummer + statusbadge op één regel, de rest als metaregel.
        // "Bedrag overgemaakt" (vinkje in het beheer) overschrijft de statusweergave:
        // de klant ziet dan altijd "Afgerond", wat de interne status ook is.
        var overgemaakt = pak(data, ['overgemaakt', 'refundTransferred'], false) === true;
        var kop = maak('li', 'rt26-tkop');
        kop.appendChild(maak('span', 'rt26-tnummer', retournr));
        var status = pak(data, ['status', 'statusLabel', 'statusNaam'], '');
        if (overgemaakt) {
          kop.appendChild(maak('span', 'rt26-status rt26-status--groen', 'Afgerond'));
        } else if (status) {
          var si = statusInfo(String(status));
          kop.appendChild(maak('span', 'rt26-status rt26-status--' + si.kleur, si.label));
        }
        dom.tsamenvatting.appendChild(kop);

        var vervoerder = pak(data, ['vervoerder', 'transporterName', 'transporter'], '');
        var meta = [];
        if (ordernr) meta.push(t('bestellingVoor') + ordernr);
        if (vervoerder) meta.push(t('metaVervoerder') + vervoerder);
        if (bestaandeTt) meta.push(t('metaTt') + bestaandeTt);
        if (meta.length) dom.tsamenvatting.appendChild(maak('li', 'rt26-tmeta', meta.join(' · ')));

        // Vaste melding bij een overgemaakte terugbetaling.
        if (overgemaakt) {
          var omEl = maak('li', 'rt26-tbericht rt26-tbericht--ok');
          omEl.appendChild(maak('strong', null, t('overgemaaktTitel')));
          omEl.appendChild(maak('span', null, t('overgemaaktTekst')));
          dom.tsamenvatting.appendChild(omEl);
        }

        // Persoonlijk bericht uit het beheer (bijv. de reden van afwijzing).
        var bericht = pak(data, ['klantBericht', 'customerMessage', 'bericht'], '');
        if (bericht) {
          var berichtEl = maak('li', 'rt26-tbericht');
          berichtEl.appendChild(maak('strong', null, t('berichtVan')));
          berichtEl.appendChild(maak('span', null, String(bericht)));
          dom.tsamenvatting.appendChild(berichtEl);
        }

        if (bestaandeTt && dom.vTtcode && !dom.vTtcode.value) dom.vTtcode.value = String(bestaandeTt);
        if (vervoerder && dom.vTtvervoerder) kiesOptie(dom.vTtvervoerder, String(vervoerder));
      }

      if (dom.tovvNummer) dom.tovvNummer.textContent = retournr || '-';

      var regels = adresRegels(pak(data, ['retouradres', 'returnAddress', 'adres'], ''));
      if (dom.tretouradres) {
        leeg(dom.tretouradres);
        if (regels.length) {
          regels.forEach(function (r) { dom.tretouradres.appendChild(maak('span', null, r)); });
        } else {
          dom.tretouradres.appendChild(maak('span', null, t('adresOntbreekt')));
        }
      }

      // Adreslabel vullen, zodat de printknop op de statuspagina hetzelfde label geeft.
      if (dom.printRetour2) dom.printRetour2.textContent = retournr || '-';
      if (dom.printAdres && regels.length) {
        leeg(dom.printAdres);
        regels.forEach(function (r) { dom.printAdres.appendChild(maak('span', null, r)); });
      }

      // Verzendhulp alleen zolang er nog geen track & trace-code is: daarna is het
      // pakket onderweg en is "zo verstuur je het" ruis.
      if (dom.tverzend) dom.tverzend.hidden = !!bestaandeTt;

      if (dom.tresultaat) dom.tresultaat.hidden = false;
      if (!stil) melding('tzoek', 'ok', t('retourGevondenTitel'), t('retourGevondenTekst'));
    }

    /**
     * Vertaalt de vrije statusteksten uit het beheer (Nederlands én Engels door
     * elkaar) naar één klantvriendelijk Nederlands label met een kleurcategorie.
     * Onbekende statussen tonen we letterlijk, in neutrale kleur.
     */
    function statusInfo(status) {
      var s = status.toLowerCase();
      if (/(overgemaakt|terugbetaald|refunded|reimbursed)/.test(s)) return { label: 'Terugbetaald', kleur: 'groen' };
      if (/(pending|aangemeld|open|in behandeling|nieuw)/.test(s)) return { label: 'In behandeling', kleur: 'amber' };
      if (/(restocked|ingeboekt|verwerkt|afgehandeld|completed|afgerond)/.test(s)) return { label: 'Afgerond', kleur: 'groen' };
      if (/(approved|goedgekeurd|akkoord)/.test(s)) return { label: 'Goedgekeurd', kleur: 'groen' };
      if (/(rejected|afgewezen|declined|geweigerd)/.test(s)) return { label: 'Afgewezen', kleur: 'rood' };
      if (/(cancelled|canceled|geannuleerd)/.test(s)) return { label: 'Geannuleerd', kleur: 'grijs' };
      return { label: status, kleur: 'neutraal' };
    }

    function kiesOptie(select, waarde) {
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].value.toLowerCase() === waarde.toLowerCase()) {
          select.selectedIndex = i;
          zetAndersVeld();
          return;
        }
      }
      // Vervoerder die niet in de lijst staat (eerder als vrije naam opgegeven):
      // zet de keuzelijst op "Anders" en toon de naam in het vrije veld.
      for (var j = 0; j < select.options.length; j++) {
        if (select.options[j].value === 'Anders') {
          select.selectedIndex = j;
          if (dom.vTtanders) dom.vTtanders.value = waarde;
          zetAndersVeld();
          return;
        }
      }
    }

    if (dom.formTcode) {
      dom.formTcode.addEventListener('submit', function (e) {
        e.preventDefault();
        if (staat.bezig) return;
        slaTtOp();
      });
    }

    /** Vrij vervoerdersveld alleen tonen als de keuzelijst op "Anders" staat. */
    function zetAndersVeld() {
      if (!dom.wrapTtanders) return;
      dom.wrapTtanders.hidden = !(dom.vTtvervoerder && dom.vTtvervoerder.value === 'Anders');
    }

    if (dom.vTtvervoerder) {
      dom.vTtvervoerder.addEventListener('change', function () {
        zetAndersVeld();
        if (dom.vTtvervoerder.value === 'Anders' && dom.vTtanders) dom.vTtanders.focus();
      });
    }

    function slaTtOp() {
      var code = (dom.vTtcode.value || '').trim();
      veldFout(dom.vTtcode, false);

      if (!code) {
        veldFout(dom.vTtcode, true);
        melding('tcode', 'err', t('ttLeegTitel'), t('ttLeegTekst'));
        dom.vTtcode.focus();
        return;
      }

      var body = { retournummer: staat.trackRetournummer, trackAndTrace: code };
      if (staat.trackIdentificatie) body.postcodeOfEmail = staat.trackIdentificatie;
      var vervoerder = dom.vTtvervoerder ? dom.vTtvervoerder.value : '';
      // Bij "Anders" telt de zelf ingevulde naam; blijft die leeg, dan sturen we
      // gewoon "Anders" mee. Beter iets dan niets.
      if (vervoerder === 'Anders' && dom.vTtanders && dom.vTtanders.value.trim()) {
        vervoerder = dom.vTtanders.value.trim();
      }
      if (vervoerder) body.vervoerder = vervoerder;

      var knop = el(root, '[data-knop="tcode"]');
      melding('tcode', '', '', '');
      bezigZet(knop, true, t('bezigOpslaan'));

      verzoek('POST', BASIS + '/track-en-trace', body).then(function () {
        bezigZet(knop, false);
        melding('tcode', 'ok', t('ttOpgeslagenTitel'), t('ttOpgeslagenTekst'));
        // Ververs de samenvatting bovenaan, zodat de zojuist opgeslagen code en
        // vervoerder daar direct zichtbaar zijn in plaats van pas na een nieuwe
        // zoekactie. Stil: de "opgeslagen"-bevestiging moet blijven staan.
        zoekRetour(true);
      }, function (e) {
        bezigZet(knop, false);
        toonFout('tcode', e, t('ttOpslaanMisluktTitel'), t('ttOpslaanMisluktTekst'));
      });
    }

    /* ── Beginstand ────────────────────────────────────────────────────── */

    var orderParam = queryParam('order').trim();
    if (orderParam && dom.vOrdernummer) {
      dom.vOrdernummer.value = orderParam;
      // Ingelogd + ordernummer uit de accountomgeving: de proxy herkent de klant al, dus
      // het identificatieveld is overbodig. Bij een 404 komt het alsnog tevoorschijn.
      if (INGELOGD && dom.wrapIdentificatie) dom.wrapIdentificatie.hidden = true;
    }
    if (INGELOGD && dom.vIdentificatie) {
      var hint = dom.vIdentificatie.parentNode ? el(dom.vIdentificatie.parentNode, '.rt26-hint') : null;
      if (hint) hint.textContent = t('ingelogdHint');
    }
    if (INGELOGD && dom.vTidentificatie) {
      var thint = dom.vTidentificatie.parentNode ? el(dom.vTidentificatie.parentNode, '.rt26-hint') : null;
      if (thint) thint.textContent = t('ingelogdHintKort');
    }

    // Verwijzing vanuit een mail of het beheer: ?stap=track opent direct de status- en
    // T&T-modus (de oude /pages/retour-status is een redirect hierheen mét die
    // parameter). Geen scroll bij het laden, de bezoeker hoort gewoon bovenaan te beginnen.
    // ?retour=R20260002 opent dezelfde modus met het retournummer voorgevuld, de link die
    // Berry naar een klant stuurt als de retour handmatig in het beheer is ingevoerd
    // (de klant kent zijn retournummer dan niet). Alleen het nummer; identificatie
    // (postcode/e-mail) blijft nodig, dus de link geeft niets prijs.
    var retourParam = queryParam('retour').replace(/^#/, '').slice(0, 40);
    if (retourParam && dom.vTretournummer) dom.vTretournummer.value = retourParam;
    // ?postcode= (aanbevolen) of ?email= vult de identificatie vast in. Met retournummer
    // én identificatie in de link zoeken we direct op: de klant klikt en ziet zijn
    // retour, zonder iets in te vullen. In klantlinks liever de postcode dan het
    // e-mailadres, URL's belanden in analytics en logs.
    var idParam = (queryParam('postcode') || queryParam('email') || queryParam('gegevens')).slice(0, 80);
    if (idParam && dom.vTidentificatie) dom.vTidentificatie.value = idParam;
    // cfg.start === 'track': de sectie-instelling (theme editor) waarmee de pagina ook
    // zonder queryparameter in de status/T&T-modus opent.
    if (retourParam || cfg.start === 'track' || queryParam('stap').toLowerCase() === 'track') {
      stapNaar('track', false);
      if (retourParam && idParam) dienTzoekIn();
    }
    else stapNaar('1', false);
  }

  function start() {
    alle(document, '[data-retour]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Theme-editor: opnieuw initialiseren nadat de sectie hertekend is.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-retour]') : null;
    if (root) init(root);
  });
})();
